import React, { useEffect, useState } from 'react'
import axios from 'axios'

export default function UGCPending() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [reason, setReason] = useState('')
  const [rejectId, setRejectId] = useState(null)

  const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` }

  async function load() {
    setLoading(true)
    try {
      const res = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/ugc/pending`, { headers })
      setRows(res?.data?.submissions || [])
    } catch (e) {
      alert(e?.response?.data?.message || e.message)
    } finally { setLoading(false) }
  }

  useEffect(() => { load() }, [])

  async function approve(id) { await axios.post(`${process.env.REACT_APP_Baseurl}/admin/ugc/${id}/approve`, {}, { headers }); load() }
  async function reject(id) { await axios.post(`${process.env.REACT_APP_Baseurl}/admin/ugc/${id}/reject`, { reason }, { headers }); setRejectId(null); setReason(''); load() }
  async function remove(id) { if (!window.confirm('Delete this UGC submission?')) return; await axios.delete(`${process.env.REACT_APP_Baseurl}/admin/ugc/${id}`, { headers }); load() }

  return (
    <div className='container py-4'>
      <h2 className='theme-text-color'>UGC Approval</h2>
      {loading ? <div className='theme-text-color'>Loading...</div> : (
        <div className='table-responsive'>
          <table className='table table-striped'>
            <thead><tr><th>Title</th><th>Poster</th><th>Player</th><th>Transcoding</th><th>Actions</th></tr></thead>
            <tbody>
              {rows.length === 0 ? <tr><td colSpan={5} className='theme-text-color'>No pending items.</td></tr> : rows.map(r => (
                <tr key={r.id}>
                  <td className='theme-text-color'>{r.title}</td>
                  <td>{r.image_URL ? <img src={r.image_URL} alt='poster' style={{width:80,height:45,objectFit:'cover'}}/> : '-'}</td>
                  <td>{r.player_image_URL ? <img src={r.player_image_URL} alt='player' style={{width:80,height:45,objectFit:'cover'}}/> : '-'}</td>
                  <td className='theme-text-color'>{['Uploaded','Queued','Processing','Done','Failed'][r.transcoding_status||0]}</td>
                  <td>
                    <button className='btn btn-success btn-sm me-2' onClick={()=>approve(r.id)}>Approve</button>
                    {rejectId===r.id? (
                      <div className='d-inline-flex gap-2'>
                        <input className='form-control form-control-sm' value={reason} onChange={(e)=>setReason(e.target.value)} placeholder='Reason' />
                        <button className='btn btn-danger btn-sm' onClick={()=>reject(r.id)}>Confirm</button>
                        <button className='btn btn-secondary btn-sm' onClick={()=>{setRejectId(null);setReason('')}}>Cancel</button>
                      </div>
                    ) : (
                      <button className='btn btn-outline-danger btn-sm me-2' onClick={()=>setRejectId(r.id)}>Reject</button>
                    )}
                    <button className='btn btn-outline-secondary btn-sm' onClick={()=>remove(r.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}